// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.2.0
//   protoc               v5.28.0
// source: plugin/metadata.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { AccessCheckChain } from "../access_check/access_check";
import { Argument } from "./argument";
import { Command } from "./command";
import { EscalatedPrivilege, escalatedPrivilegeFromJSON, escalatedPrivilegeToJSON } from "./escalated_privilege";

/** Metadata for a plugin. */
export interface Metadata {
  /** The plguins name. */
  name: string;
  /** A short description of the plugin. */
  description: string;
  /**
   * A version string for the plugin. Should follow semver.
   *
   * @see: https://semver.org/
   */
  version: string;
  /**
   * When true, a SQLite3 database will be created for the plugin.
   * @deprecated All plugins get a database by default now.
   */
  database: boolean;
  /**
   * Access checks
   *
   * All functionality of this plugin can optionally be gated by accses checks.
   */
  accessChecks?:
    | AccessCheckChain
    | undefined;
  /**
   * A secret escalation key that grants this plugin specific escalated
   * privileges.
   */
  escalationKey?:
    | string
    | undefined;
  /** A list of escalated privileges that this plugin requests to use. */
  escalatedPrivileges: EscalatedPrivilege[];
  /** The author of the plugin. */
  author: string;
  /** Whether or not this plugin handles commands. */
  handlesCommands: boolean;
  /** Whether or not this plugin handles messages. */
  handlesMessages: boolean;
  /** Optionally override the plugin command name. */
  commandName?:
    | string
    | undefined;
  /** Optional aliases for the plugin command. */
  aliases: string[];
  /** Arguments for the plugin command. */
  arguments: Argument[];
  /** Plugin subcommands. */
  subcommands: Command[];
  /** Hosts that this plugin requests permissions to access via HTTP. */
  allowedHosts: string[];
  /** Pool size this plugin requests. */
  poolSize?:
    | number
    | undefined;
  /**
   * Show help if no args are passed to the plugin command.
   *
   * NOTE: Subcommands count as arguments.
   */
  argRequiredElseHelp: boolean;
}

function createBaseMetadata(): Metadata {
  return {
    name: "",
    description: "",
    version: "",
    database: false,
    accessChecks: undefined,
    escalationKey: undefined,
    escalatedPrivileges: [],
    author: "",
    handlesCommands: false,
    handlesMessages: false,
    commandName: undefined,
    aliases: [],
    arguments: [],
    subcommands: [],
    allowedHosts: [],
    poolSize: undefined,
    argRequiredElseHelp: false,
  };
}

export const Metadata: MessageFns<Metadata> = {
  encode(message: Metadata, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }
    if (message.version !== "") {
      writer.uint32(26).string(message.version);
    }
    if (message.database !== false) {
      writer.uint32(32).bool(message.database);
    }
    if (message.accessChecks !== undefined) {
      AccessCheckChain.encode(message.accessChecks, writer.uint32(42).fork()).join();
    }
    if (message.escalationKey !== undefined) {
      writer.uint32(50).string(message.escalationKey);
    }
    writer.uint32(58).fork();
    for (const v of message.escalatedPrivileges) {
      writer.int32(v);
    }
    writer.join();
    if (message.author !== "") {
      writer.uint32(66).string(message.author);
    }
    if (message.handlesCommands !== false) {
      writer.uint32(72).bool(message.handlesCommands);
    }
    if (message.handlesMessages !== false) {
      writer.uint32(80).bool(message.handlesMessages);
    }
    if (message.commandName !== undefined) {
      writer.uint32(90).string(message.commandName);
    }
    for (const v of message.aliases) {
      writer.uint32(98).string(v!);
    }
    for (const v of message.arguments) {
      Argument.encode(v!, writer.uint32(106).fork()).join();
    }
    for (const v of message.subcommands) {
      Command.encode(v!, writer.uint32(114).fork()).join();
    }
    for (const v of message.allowedHosts) {
      writer.uint32(122).string(v!);
    }
    if (message.poolSize !== undefined) {
      writer.uint32(128).int32(message.poolSize);
    }
    if (message.argRequiredElseHelp !== false) {
      writer.uint32(136).bool(message.argRequiredElseHelp);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Metadata {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMetadata();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.description = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.version = reader.string();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.database = reader.bool();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.accessChecks = AccessCheckChain.decode(reader, reader.uint32());
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.escalationKey = reader.string();
          continue;
        case 7:
          if (tag === 56) {
            message.escalatedPrivileges.push(reader.int32() as any);

            continue;
          }

          if (tag === 58) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.escalatedPrivileges.push(reader.int32() as any);
            }

            continue;
          }

          break;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.author = reader.string();
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.handlesCommands = reader.bool();
          continue;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.handlesMessages = reader.bool();
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.commandName = reader.string();
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.aliases.push(reader.string());
          continue;
        case 13:
          if (tag !== 106) {
            break;
          }

          message.arguments.push(Argument.decode(reader, reader.uint32()));
          continue;
        case 14:
          if (tag !== 114) {
            break;
          }

          message.subcommands.push(Command.decode(reader, reader.uint32()));
          continue;
        case 15:
          if (tag !== 122) {
            break;
          }

          message.allowedHosts.push(reader.string());
          continue;
        case 16:
          if (tag !== 128) {
            break;
          }

          message.poolSize = reader.int32();
          continue;
        case 17:
          if (tag !== 136) {
            break;
          }

          message.argRequiredElseHelp = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Metadata {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      version: isSet(object.version) ? globalThis.String(object.version) : "",
      database: isSet(object.database) ? globalThis.Boolean(object.database) : false,
      accessChecks: isSet(object.accessChecks) ? AccessCheckChain.fromJSON(object.accessChecks) : undefined,
      escalationKey: isSet(object.escalationKey) ? globalThis.String(object.escalationKey) : undefined,
      escalatedPrivileges: globalThis.Array.isArray(object?.escalatedPrivileges)
        ? object.escalatedPrivileges.map((e: any) => escalatedPrivilegeFromJSON(e))
        : [],
      author: isSet(object.author) ? globalThis.String(object.author) : "",
      handlesCommands: isSet(object.handlesCommands) ? globalThis.Boolean(object.handlesCommands) : false,
      handlesMessages: isSet(object.handlesMessages) ? globalThis.Boolean(object.handlesMessages) : false,
      commandName: isSet(object.commandName) ? globalThis.String(object.commandName) : undefined,
      aliases: globalThis.Array.isArray(object?.aliases) ? object.aliases.map((e: any) => globalThis.String(e)) : [],
      arguments: globalThis.Array.isArray(object?.arguments)
        ? object.arguments.map((e: any) => Argument.fromJSON(e))
        : [],
      subcommands: globalThis.Array.isArray(object?.subcommands)
        ? object.subcommands.map((e: any) => Command.fromJSON(e))
        : [],
      allowedHosts: globalThis.Array.isArray(object?.allowedHosts)
        ? object.allowedHosts.map((e: any) => globalThis.String(e))
        : [],
      poolSize: isSet(object.poolSize) ? globalThis.Number(object.poolSize) : undefined,
      argRequiredElseHelp: isSet(object.argRequiredElseHelp) ? globalThis.Boolean(object.argRequiredElseHelp) : false,
    };
  },

  toJSON(message: Metadata): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.version !== "") {
      obj.version = message.version;
    }
    if (message.database !== false) {
      obj.database = message.database;
    }
    if (message.accessChecks !== undefined) {
      obj.accessChecks = AccessCheckChain.toJSON(message.accessChecks);
    }
    if (message.escalationKey !== undefined) {
      obj.escalationKey = message.escalationKey;
    }
    if (message.escalatedPrivileges?.length) {
      obj.escalatedPrivileges = message.escalatedPrivileges.map((e) => escalatedPrivilegeToJSON(e));
    }
    if (message.author !== "") {
      obj.author = message.author;
    }
    if (message.handlesCommands !== false) {
      obj.handlesCommands = message.handlesCommands;
    }
    if (message.handlesMessages !== false) {
      obj.handlesMessages = message.handlesMessages;
    }
    if (message.commandName !== undefined) {
      obj.commandName = message.commandName;
    }
    if (message.aliases?.length) {
      obj.aliases = message.aliases;
    }
    if (message.arguments?.length) {
      obj.arguments = message.arguments.map((e) => Argument.toJSON(e));
    }
    if (message.subcommands?.length) {
      obj.subcommands = message.subcommands.map((e) => Command.toJSON(e));
    }
    if (message.allowedHosts?.length) {
      obj.allowedHosts = message.allowedHosts;
    }
    if (message.poolSize !== undefined) {
      obj.poolSize = Math.round(message.poolSize);
    }
    if (message.argRequiredElseHelp !== false) {
      obj.argRequiredElseHelp = message.argRequiredElseHelp;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Metadata>, I>>(base?: I): Metadata {
    return Metadata.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Metadata>, I>>(object: I): Metadata {
    const message = createBaseMetadata();
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.version = object.version ?? "";
    message.database = object.database ?? false;
    message.accessChecks = (object.accessChecks !== undefined && object.accessChecks !== null)
      ? AccessCheckChain.fromPartial(object.accessChecks)
      : undefined;
    message.escalationKey = object.escalationKey ?? undefined;
    message.escalatedPrivileges = object.escalatedPrivileges?.map((e) => e) || [];
    message.author = object.author ?? "";
    message.handlesCommands = object.handlesCommands ?? false;
    message.handlesMessages = object.handlesMessages ?? false;
    message.commandName = object.commandName ?? undefined;
    message.aliases = object.aliases?.map((e) => e) || [];
    message.arguments = object.arguments?.map((e) => Argument.fromPartial(e)) || [];
    message.subcommands = object.subcommands?.map((e) => Command.fromPartial(e)) || [];
    message.allowedHosts = object.allowedHosts?.map((e) => e) || [];
    message.poolSize = object.poolSize ?? undefined;
    message.argRequiredElseHelp = object.argRequiredElseHelp ?? false;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
